import React from 'react';
import { Tag } from 'antd';
import { styled } from 'styled-components';
import { CUSTOM_EXPORT_STATUS_CONFIG, CustomExportStatus } from '../customExportLib';

const StatusTag = styled(Tag)<{ $backgroundColor?: string; $textColor?: string }>`
  min-width: 7rem;
  text-align: center;
  background-color: ${p => p.$backgroundColor ?? '#f3f4f6'};
  color: ${p => p.$textColor ?? '#374151'};
  border: none;
`;

interface CustomExportStatusBadgeProps {
  status?: CustomExportStatus | null;
}

const CustomExportStatusBadge: React.FC<CustomExportStatusBadgeProps> = ({ status }) => {
  if (!status) return null;

  const config = CUSTOM_EXPORT_STATUS_CONFIG[status];

  return (
    <StatusTag bordered={false} $backgroundColor={config.backgroundColor} $textColor={config.color}>
      {config.label}
    </StatusTag>
  );
};

export default CustomExportStatusBadge;
